import {
    DataRecord,
    getMetricLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, GaugeSeriesOption } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_CHART_FORM_DATA,
    EchartsGaugeChartProps,
    EchartsGaugeFormData,
    GaugeChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
  
export default function transformProps(
    chartProps: EchartsGaugeChartProps,
): GaugeChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      metrics,
      showLabels,
      tooltipFormat,
      valueFormat,
      rangeMax,
      showLegend
    }: EchartsGaugeFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_CHART_FORM_DATA,
      ...formData,
    };
    const metricLabels = metrics ? metrics.map(getMetricLabel) : [];
  
    const { setDataMask = () => {} } = hooks;

    const offsetCenter: { title: {[key: number]: string[]}, detail: {[key: number]: string[]} }[] = [
      {
        title: {
          0: ['0%', '0%'],
        },
        detail: {
          0: ['0%', '20%'],
        }
      },
      {
        title: {
          0: ['0%', '-30%'],
          1: ['0%', '10%'],
        },
        detail: {
          0: ['0%', '-10%'],
          1: ['0%', '30%'],
        }
      },
      {
        title: {
          0: ['0%', '-40%'],
          1: ['0%', '0%'],
          2: ['0%', '40%']
        },
        detail: {
          0: ['0%', '-20%'],
          1: ['0%', '20%'],
          2: ['0%', '60%']
        }
      },
    ]

    const seriesData = data.length === 1 ? metricLabels.map((metricLabel, idx) => {
      return {
        name: metricLabel,
        value: data[0][metricLabel],
        title: {
          show: showLabels,
          offsetCenter: offsetCenter[metricLabels.length - 1].title[idx]
        },
        detail: {
          show: showLabels,
          valueAnimation: true,
          offsetCenter: offsetCenter[metricLabels.length - 1].detail[idx]
        }
      };
    }) : [];
    
    const series: GaugeSeriesOption[] = [
      {
        type: 'gauge',
        max: parseInt(rangeMax, 10),
        startAngle: 90,
        endAngle: -270,
        pointer: {
          show: false
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {
            borderWidth: 1,
            borderColor: '#464646'
          }
        },
        axisLine: {
          lineStyle: {
            width: 40
          }
        },
        splitLine: {
          show: false,
          distance: 0,
          length: 10
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false,
          distance: 50
        },
        title: {
          fontSize: 14
        },
        detail: {
          width: 50,
          height: 14,
          fontSize: 14,
          color: 'inherit',
          borderColor: 'inherit',
          borderRadius: 20,
          borderWidth: 1,
          formatter: valueFormat
        },
        // @ts-ignore
        data: seriesData,
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      tooltip: {
        formatter: tooltipFormat
      },
      legend: {
        show: showLegend
      },
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
    };
}
  